import Logo from './Logo'

export * from './Logo'

export default Logo
